module.exports = __webpack_public_path__ + "img/macos.e6315759.jpg";